"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentWrapper = void 0;
const styles_1 = require("@mui/material/styles");
exports.ContentWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    minHeight: "300px",
    button: {
        marginTop: 20,
    },
});
